import React from 'react';
import { BrowserRouter as Router,Link } from 'react-router-dom';
import {handleSearch, addSearchTitle} from '../actions';
import { Brightness7Outlined, Brightness4Outlined } from '@material-ui/icons';
import { IconButton } from '@material-ui/core'

class Navbar extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            search:''
        }
    }

  
    
    render(){
  
    
    return (
        <div className="Navbar">
        <Link to="/" style={{textDecoration:'none'}}>
           <p className="logo">Let's Watch</p>
           </Link>
           <div className="form">
           <form>
               <input
                   onChange={(e)=>{
                            console.log(e);
                            this.setState({search:e.target.value});
                            if(e.target.value==null){
                                return;
                            }
                            this.props.dispatch(handleSearch(e.target.value));
                            this.props.dispatch(addSearchTitle(e.target.value));
                            window.scrollTo({
                top: 0,
                behavior: "smooth"
              });
                            
                       }} 
                       placeholder="Search..." value={this.state.search}
               />

            {this.state.search!=''&&<Link to="/search">
               <button className="search-btn">Search</button>
           </Link>
            }
           </form>
           </div>
           <div style={{marginRight:'40px'},{color:'white'}}>
           <IconButton style={{backgroundColor:'white'}}>
              <Brightness4Outlined fontSize='small' />
              </IconButton>
           </div>

        </div>
    )
    }
}

export default Navbar
